'use strict';

(function ($) {

    $(function () {
        bannerHeightCaculator();

        function bannerHeightCaculator() {
            var headerHeight = $("header").height();

            if ($("#wpadminbar").length > 0) {
                var wpadminbar = $("#wpadminbar").height();
                headerHeight = headerHeight + wpadminbar;
            }
            var banerHeight = window.innerHeight - headerHeight;

            if ($(".banner-block__main--image").length > 0) {
                if ($(window).width() > 990) {
                    $(".banner-block__main--image").height(banerHeight);
                    $(".banner-block__main--content").css('height', 'auto');
                } else {
                    $('.banner-block__main').height(banerHeight);
                    var heightContent = $('.banner-block__main--content').height();
                    var heightImage = banerHeight - heightContent - 125;
                    $('.banner-block__main--image').height(heightImage);
                }
            }

            if ($(".banner-text__main--image").length > 0) {
                $(".banner-text__main--image").height(banerHeight);
            }

            $(".home-banner__item--image").height(banerHeight);
        }

        $(document).on('click', '.properties-explore__item--main', function (e) {
            if (!$(this).hasClass('active')) {
                $('.properties-explore__item--main').removeClass('active');
            }
            $(this).toggleClass('active');
        });

        $(document).on('click', '.properties-explore__item--content a', function (e) {
            e.preventDefault();
        });

        var width_started = 0;
        var margin_left = 0;
        if ($(".properties-ammenities__main").length) {
            var elements_html = $('.properties-ammenities__main').html();
            $('.properties-ammenities__main > div').each(function (index) {
                width_started += $(this).width();
            });
            $('.properties-ammenities__main').append(elements_html);
            $('.properties-ammenities__main').prepend(elements_html);
            $('.properties-ammenities__main').prepend(elements_html);
            $('.properties-ammenities__main').prepend('<div class="flex-none w-20 h-50 -mr-20" style="margin-left: -' + width_started + 'px;"></div>');

            setInterval(function () {
                margin_left = margin_left + .8;

                $(".properties-ammenities__main").animate({
                    'margin-left': '-' + margin_left + 'px'
                }, 30);

                if (margin_left >= width_started) {
                    margin_left = 0;
                }
            }, 30);
        }

        $(".anchor").click(function (e) {
            e.preventDefault();
            var href = $(this).attr('href');
            var top = $(href).offset().top;
            $("html, body").animate({scrollTop: top - 30}, 1000);
        });

        if ($('.room-detail__main').length > 0) {
            var stickImage = new StickySidebar('.desktop .room-detail__main--image-sticky', {
                topSpacing: 40,
                bottomSpacing: 20,
                containerSelector: '.room-detail__main',
                innerWrapperSelector: '.desktop.room-detail__main--image',
                minWidth: 991
            });
        }

        $(".room-decs__main h2").click(function () {
            if ($(window).width() < 992) {
                $(this).toggleClass('close');
                $(this).parent().find('.decs').slideToggle();
            }
        });

        $(".faq__item> h4").click(function () {
            $(this).toggleClass('close');
            $(this).parent().toggleClass('open').find('.faq__item__main').slideToggle();
        });

        $(".close__advert").click(function () {
            $('header__advert').hide();
            $('body').removeClass('has-promotional-banner');
        });

        $(".seo-copy .read-btn").click(function (e) {
            $(this).closest('.seo-copy').toggleClass('opening');
        }); 

        $(".properties-cover__mains .read-btn").click(function (e) {
            $(this).closest('.properties-cover__mains').toggleClass('opening');
        }); 

      
        /**
         * Handle sub menu
         */

        if ($(".footer__top--main").length && $(window).width() < 768) {
            $(".footer__top--main>ul>li>a").click(function (e) {
                e.preventDefault();
                $(this).toggleClass('active');
                $(this).parent().find('ul').toggleClass('active');
            });
        }

        $(document).on("click", function (event) {
            if ($(event.target).closest("#page-locations").length === 0) {
            //   console.log("You clicked outside of the container element");

              if( $("#page-locations > a").hasClass('active')){
                $("#page-locations > a").removeClass('active');
              }
              if( $("#page-locations > .menu_mega").hasClass('active')){
                $("#page-locations > .menu_mega").removeClass('active');
              }
             
            }
          });
        

        $(".button__menu-open").click(function (e) {
            e.preventDefault();
            $(".button__menu-open").toggleClass('open');
            $('body').toggleClass('open-menu');
        });

        $('body').click(function (event) {
            var target = event.target;
            var menuLocationClass = $(target).attr('class');
            var datashow = $('.menu_locations').attr('data-show');
            if (datashow && menuLocationClass == undefined) {
                $(".menu_locations").removeClass('active').attr('data-show', '');
                return;
            }

            if (datashow && (menuLocationClass != '' && menuLocationClass.search('active') == -1)) {
                $(".menu_locations").removeClass('active').attr('data-show', '');
            }
        });

        $(".menu-item-has-children>a").click(function (e) {
            e.preventDefault();

            if($(this).hasClass('active')){   
                $(".menu-item-has-children a").removeClass('active');
                $(".menu-item-has-children .menu_locations").removeClass('active');
            }else{
                $(".menu-item-has-children a").removeClass('active');
                $(".menu-item-has-children .menu_locations").removeClass('active');
                $(this).addClass('active');
                $(this).closest('.menu-item-has-children').find(".menu_locations").toggleClass('active');
            }
            if($(window).width() < 991){   
                $('.menu_locations__main').slick('refresh');
            }
        });

        slidersubmenu();

        function slidersubmenu() {
            if ($(".menu_locations__main > .menu_locations__item").length) {
                var menu_locations__main = $(".menu_locations__main").not('.slick-initialized').slick({
                    slidesToShow: 4,
                    arrows: false,
                    infinite: false,
                    responsive: [{
                        breakpoint: 9999,
                        settings: "unslick"
                    }, {
                        breakpoint: 992,
                        centerMode: true,
                        centerPadding: '20%',
                        settings: {
                            slidesToShow: 3.2
                        }
                    }, {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2.2
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1.2 
                        }
                    }]
                });
            }
        }


        $('.box-slider').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            variableWidth: true,
            adaptiveHeight: true,
            arrows: true,
            fade: false,
            dots: false,
            infinite: false,
            prevArrow: '<button type="button" class="slick-prev" style=""><svg xmlns="http://www.w3.org/2000/svg" width="14" height="26" viewBox="0 0 14 26" fill="none"><path d="M0.00980706 13.188C0.0533732 13.4769 0.184071 13.7441 0.38738 13.9535L11.5403 25.5085C11.789 25.801 12.1466 25.9779 12.5296 25.9978C12.9126 26.0194 13.2884 25.8822 13.5661 25.6204C13.8457 25.3568 14.0018 24.9903 14 24.6094C14 24.2266 13.8402 23.8637 13.5589 23.6019L3.32096 13L13.5589 2.39808C13.8402 2.13629 14 1.77338 14 1.39063C14.0018 1.00968 13.8457 0.643166 13.5661 0.379574C13.2884 0.117779 12.9127 -0.0194357 12.5296 0.00222793C12.1466 0.0220872 11.789 0.199022 11.5403 0.491512L0.389238 12.0465C0.0951677 12.3498 -0.0427939 12.7705 0.0116649 13.1876L0.00980706 13.188Z" fill="#242A56"/></svg></button>',
		    nextArrow: '<button type="button" class="slick-next" style=""><svg xmlns="http://www.w3.org/2000/svg" width="14" height="26" viewBox="0 0 14 26" fill="none"><path d="M13.9902 12.812C13.9466 12.5231 13.8159 12.2559 13.6126 12.0465L2.4597 0.491509C2.21101 0.199025 1.8534 0.0221001 1.47039 0.00222555C1.08737 -0.0194401 0.711616 0.117775 0.433862 0.379569C0.154314 0.643166 -0.00180159 1.00968 1.60743e-05 1.39063C1.60363e-05 1.77339 0.159757 2.13629 0.441123 2.39808L10.679 13L0.441121 23.6019C0.159755 23.8637 1.38056e-05 24.2266 1.37676e-05 24.6094C-0.00180207 24.9903 0.154312 25.3568 0.433859 25.6204C0.711595 25.8822 1.08733 26.0194 1.47038 25.9978C1.8534 25.9779 2.21103 25.801 2.45969 25.5085L13.6108 13.9535C13.9048 13.6502 14.0428 13.2295 13.9883 12.8124L13.9902 12.812Z" fill="#242A56"/></svg></button>',
            responsive: [
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: true,
                    },
                },
                {
                    breakpoint: 576,
                    settings: {
                        // arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: true,
                    },
                },
            ]
        });


        function getMobileOperatingSystem() {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
            if (/android/i.test(userAgent)) {
                $('body').addClass('android-device');
            }
        
            // iOS detection from: http://stackoverflow.com/a/9039885/177710
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                $('body').addClass('ios-device');
            }
        }
        getMobileOperatingSystem();


        $( window ).on( "load", function() {
 
            // if ($.fn.masonry) {
                // setTimeout(function () {
                //     $('.grid-instagram').masonry({
                //         // options
                //         itemSelector: '.grid-item',
                //         columnWidth: ".grid-sizer",
                //         percentPosition: true
                //     }); 
                // }, 1000);

                // $('.grid-instagram').on( 'layoutComplete', function() {
                //     console.log('layout is complete, just once');
                //     $(this).addClass('layout-loaded');
                //     setTimeout(function () {
                //         $(this).masonry( 'reloadItems' );
                //         $(this).masonry( 'layout' );
                //     }, 1000);
                // });


                if($('.grid-instagram .grid-item').length <= 6){
                    $('.grid-instagram').addClass('ruby-text');
                }

                $('body').on('click', '.loadmore-btn a', function(e){
                    e.preventDefault();
                    var next = $(this).data('next');
                    var type = $(this).data('type');
                    var ist_block = $(this).closest('.block-instagram').find('.grid-instagram');

                    $(this).closest('.block-instagram').addClass('loading');

                    var data = {
                        action: 'ins_ajax_load_more',
                        type: type,
                        next: next,
                    };
                    $.ajax({
                        url: scapeAjax.ajaxurl,
                        method: 'POST',
                        data: data,
                        success: json => {
                            
                            // console.log(json);
                            ist_block.append(json.html);
                            setTimeout(function () {
                                ist_block.imagesLoaded(function () {
                                    ist_block.masonry( 'reloadItems' );
                                    ist_block.masonry( 'layout' );
                                });
                            
                            }, 500);

                            setTimeout(function () {
                                ist_block.find( '.not-ready' ).removeClass('not-ready');
                            }, 500);

                            $(this).closest('.block-instagram').removeClass('loading');

                            console.log(json); 
                        
                            if(json.next != null){
                                $(this).data('next',json.next);
                            
                            }else{
                                $(this).closest('.loadmore-btn').remove();
                            }

                            if($('.grid-instagram .grid-item').length <= 6){
                                $('.grid-instagram').addClass('ruby-text');
                            }else{
                                $('.grid-instagram').removeClass('ruby-text');
                                $('.grid-instagram').removeClass('just-align-center');
                            }

                            

                        },
                        error: (jqXHR, textStatus) => {
                        }
                    });
                    
                });
                        
            // }
        });

        $('.select2').select2({
            minimumResultsForSearch: -1
        });

        $(".jobs-type").select2({
            minimumResultsForSearch: -1,
            containerCssClass: "errorsss",
            dropdownCssClass: "jobs-type-dropdown",
            enable: false
        });
        $(".jobs-type").prop("disabled", true); 

        $(".booking_time").select2({
            minimumResultsForSearch: -1,
            containerCssClass: "errorsss",
            dropdownCssClass: "booking-time-dropdown"
        });

        $('#search-map').select2({
            minimumResultsForSearch: -1,
            dropdownCssClass: "search-map-dropdown"
        });



        $('.close__advert').click(function () {
            $(".header__advert").hide();
            $('body').removeClass('has-promotional-banner');
        });

        // $(".terms__main").mCustomScrollbar();

        if ($(".video").length) {
            $(".video video").attr('controls', false);
            $(".video .play-icon").click(function (e) {
                e.preventDefault();
                $(this).parent().addClass('playing');
                var video = $(this).parent().find('video');
                video.attr('controls', true);
                video.trigger('play');
                //$('.city-about__video--main').slick('refresh');
            });

            //Vimeo Video
            var video_frame = document.querySelectorAll(".video.vimeo iframe");
            var play_btn = document.querySelectorAll(".play-icon-video.vimeo");
            var nodelist = video_frame.length;
            for (var i = 0; i < nodelist; i++) {
                let player = new Vimeo.Player(video_frame[i]);
                play_btn[i].addEventListener('click', function () {
                    $(this).parent().addClass('playing');
                    player.play();
                });
            }

            //Youtube Video
            $(".play-icon-video.youtube").click(function (e) {
                e.preventDefault();
                $(this).parent().addClass('playing');
                $(this).parent().find('iframe')[0].src += "?autoplay=1";
                //$('.city-about__video--main').slick('refresh');
            });
        }

        if ($(".promotion__item").length > 1) {
            var $slider = $('.promotion__items');

            var currentSlide;
            var slidesPromotionCount;
            var sliderPromotionCounter = document.createElement('div');
            sliderPromotionCounter.classList.add('promotion__items--slider__counter');

            var updatePromotionSliderCounter = function updatePromotionSliderCounter(slick, currentIndex) {
                currentSlide = slick.slickCurrentSlide() + 1;
                slidesPromotionCount = slick.slideCount;
                $(sliderPromotionCounter).text(currentSlide + '/' + slidesPromotionCount);
            };

            $slider.on('init', function (event, slick) {
                $slider.append(sliderPromotionCounter);
                updatePromotionSliderCounter(slick);
            });

            $slider.on('afterChange', function (event, slick, currentSlide) {
                updatePromotionSliderCounter(slick, currentSlide);
            });

            $slider.not('.slick-initialized').slick({
                slidesToShow: 1,
                arrows: true,
                speed: 500,
                asNavFor: '.promotion__images',
                prevArrow: '<button type="button" class="slick-prev" style="" aria-label="prev"><span class="sr-only">Prev</span><svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M0.00980706 13.188C0.0533732 13.4769 0.184071 13.7441 0.38738 13.9535L11.5403 25.5085C11.789 25.801 12.1466 25.9779 12.5296 25.9978C12.9126 26.0194 13.2884 25.8822 13.5661 25.6204C13.8457 25.3568 14.0018 24.9903 14 24.6094C14 24.2266 13.8402 23.8637 13.5589 23.6019L3.32096 13L13.5589 2.39808C13.8402 2.13629 14 1.77338 14 1.39063C14.0018 1.00968 13.8457 0.643166 13.5661 0.379574C13.2884 0.117779 12.9127 -0.0194357 12.5296 0.00222793C12.1466 0.0220872 11.789 0.199022 11.5403 0.491512L0.389238 12.0465C0.0951677 12.3498 -0.0427939 12.7705 0.0116649 13.1876L0.00980706 13.188Z" fill="white"/>\n' + '</svg></button>',
                nextArrow: '<button type="button" class="slick-next" style="" aria-label="next"><span class="sr-only">Next</span>' + '<svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M13.9902 12.812C13.9466 12.5231 13.8159 12.2559 13.6126 12.0465L2.4597 0.491509C2.21101 0.199025 1.8534 0.0221001 1.47039 0.00222555C1.08737 -0.0194401 0.711616 0.117775 0.433862 0.379569C0.154314 0.643166 -0.00180159 1.00968 1.60743e-05 1.39063C1.60363e-05 1.77339 0.159757 2.13629 0.441123 2.39808L10.679 13L0.441121 23.6019C0.159755 23.8637 1.38056e-05 24.2266 1.37676e-05 24.6094C-0.00180207 24.9903 0.154312 25.3568 0.433859 25.6204C0.711595 25.8822 1.08733 26.0194 1.47038 25.9978C1.8534 25.9779 2.21103 25.801 2.45969 25.5085L13.6108 13.9535C13.9048 13.6502 14.0428 13.2295 13.9883 12.8124L13.9902 12.812Z" fill="white"/>\n' + '</svg></button>'
            });

            $(".promotion__images").not('.slick-initialized').slick({
                slidesToShow: 1,
                arrows: false,
                fade: true,
                speed: 500,
                cssEase: 'linear',
                asNavFor: '.promotion__items',
            });
        }

        if ($(".city-about__video--main").length > 0) {
            var $slider = $('.city-about__video--main');

            var currentCitySlide;
            var slidesCityCount;
            var sliderCityCounter = document.createElement('div');
            var $classControl = 'city-about__video--main__slider__counter';
            if ($(".city-about__video--main .city-about__video--image").length == 1) {
                $classControl = 'scape-hidden';
            }
            sliderCityCounter.classList.add($classControl);

            var updateCitySliderCounter = function updateCitySliderCounter(slick, currentIndex) {
                currentCitySlide = slick.slickCurrentSlide() + 1;
                slidesCityCount = slick.slideCount;
                $(sliderCityCounter).text(currentCitySlide + '/' + slidesCityCount);
            };

            $slider.on('init', function (event, slick) {
                $slider.append(sliderCityCounter);
                updateCitySliderCounter(slick);
            });

            $slider.on('afterChange', function (event, slick, currentSlide) {
                updateCitySliderCounter(slick, currentSlide);
            });

            $slider.not('.slick-initialized').slick({
                slidesToShow: 1,
                adaptiveHeight: true,
                arrows: true,
                prevArrow: '<button type="button" class="slick-prev" style=""><svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M0.00980706 13.188C0.0533732 13.4769 0.184071 13.7441 0.38738 13.9535L11.5403 25.5085C11.789 25.801 12.1466 25.9779 12.5296 25.9978C12.9126 26.0194 13.2884 25.8822 13.5661 25.6204C13.8457 25.3568 14.0018 24.9903 14 24.6094C14 24.2266 13.8402 23.8637 13.5589 23.6019L3.32096 13L13.5589 2.39808C13.8402 2.13629 14 1.77338 14 1.39063C14.0018 1.00968 13.8457 0.643166 13.5661 0.379574C13.2884 0.117779 12.9127 -0.0194357 12.5296 0.00222793C12.1466 0.0220872 11.789 0.199022 11.5403 0.491512L0.389238 12.0465C0.0951677 12.3498 -0.0427939 12.7705 0.0116649 13.1876L0.00980706 13.188Z" fill="#FFFFFF"/>\n' + '</svg></button>',
                nextArrow: '<button type="button" class="slick-next" style=""><svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M13.9902 12.812C13.9466 12.5231 13.8159 12.2559 13.6126 12.0465L2.4597 0.491509C2.21101 0.199025 1.8534 0.0221001 1.47039 0.00222555C1.08737 -0.0194401 0.711616 0.117775 0.433862 0.379569C0.154314 0.643166 -0.00180159 1.00968 1.60743e-05 1.39063C1.60363e-05 1.77339 0.159757 2.13629 0.441123 2.39808L10.679 13L0.441121 23.6019C0.159755 23.8637 1.38056e-05 24.2266 1.37676e-05 24.6094C-0.00180207 24.9903 0.154312 25.3568 0.433859 25.6204C0.711595 25.8822 1.08733 26.0194 1.47038 25.9978C1.8534 25.9779 2.21103 25.801 2.45969 25.5085L13.6108 13.9535C13.9048 13.6502 14.0428 13.2295 13.9883 12.8124L13.9902 12.812Z" fill="#FFFFFF"/>\n' + '</svg></button>'
            });
        }

        if ($(".properties-map__news-main > .properties-map__news--item").length) {
            $(".properties-map__news-main").not('.slick-initialized').slick({
                dots: true,
                slidesToShow: 1,
                arrows: true,
                prevArrow: '<button type="button" class="slick-prev" style=""><svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M0.00980706 13.188C0.0533732 13.4769 0.184071 13.7441 0.38738 13.9535L11.5403 25.5085C11.789 25.801 12.1466 25.9779 12.5296 25.9978C12.9126 26.0194 13.2884 25.8822 13.5661 25.6204C13.8457 25.3568 14.0018 24.9903 14 24.6094C14 24.2266 13.8402 23.8637 13.5589 23.6019L3.32096 13L13.5589 2.39808C13.8402 2.13629 14 1.77338 14 1.39063C14.0018 1.00968 13.8457 0.643166 13.5661 0.379574C13.2884 0.117779 12.9127 -0.0194357 12.5296 0.00222793C12.1466 0.0220872 11.789 0.199022 11.5403 0.491512L0.389238 12.0465C0.0951677 12.3498 -0.0427939 12.7705 0.0116649 13.1876L0.00980706 13.188Z" fill="#FA70A8"/>\n' + '</svg></button>',
                nextArrow: '<button type="button" class="slick-next" style=""><svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M13.9902 12.812C13.9466 12.5231 13.8159 12.2559 13.6126 12.0465L2.4597 0.491509C2.21101 0.199025 1.8534 0.0221001 1.47039 0.00222555C1.08737 -0.0194401 0.711616 0.117775 0.433862 0.379569C0.154314 0.643166 -0.00180159 1.00968 1.60743e-05 1.39063C1.60363e-05 1.77339 0.159757 2.13629 0.441123 2.39808L10.679 13L0.441121 23.6019C0.159755 23.8637 1.38056e-05 24.2266 1.37676e-05 24.6094C-0.00180207 24.9903 0.154312 25.3568 0.433859 25.6204C0.711595 25.8822 1.08733 26.0194 1.47038 25.9978C1.8534 25.9779 2.21103 25.801 2.45969 25.5085L13.6108 13.9535C13.9048 13.6502 14.0428 13.2295 13.9883 12.8124L13.9902 12.812Z" fill="#FA70A8"/>\n' + '</svg></button>'
            });
        }

        $(window).load(function() {
            if ($(".amenities-slider").length > 0) {
                $(".amenities-slider .slider-nav").not('.slick-initialized').slick({
                    slidesToShow: 1,
                    infinite: false,
                    arrows: true,
                    centerMode: true,
                    verticalSwiping: true,
                    vertical: true,
                    dots: false,
                    prevArrow: '<button type="button" class="slick-prev" style=""><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><path d="M23.7614 15.0126C23.3947 15.0686 23.0556 15.2367 22.7898 15.4981L8.12384 29.8375C7.75261 30.1573 7.52805 30.6171 7.50283 31.1095C7.47533 31.602 7.64948 32.0851 7.98176 32.4422C8.31633 32.8016 8.78152 33.0023 9.26503 33C9.75084 33 10.2115 32.7946 10.5437 32.4328L24 19.2698L37.4563 32.4328C37.7886 32.7946 38.2492 33 38.735 33C39.2185 33.0023 39.6837 32.8016 40.0182 32.4422C40.3505 32.0851 40.5247 31.602 40.4972 31.1095C40.472 30.6171 40.2474 30.1572 39.8762 29.8375L25.2102 15.5004C24.8253 15.1224 24.2913 14.945 23.7619 15.015L23.7614 15.0126Z" fill="white"/></svg></button>',
                    nextArrow: '<button type="button" class="slick-next" style=""><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><path d="M24.2386 32.9874C24.6053 32.9314 24.9444 32.7633 25.2102 32.5019L39.8762 18.1625C40.2474 17.8427 40.4719 17.3829 40.4972 16.8905C40.5247 16.398 40.3505 15.9149 40.0182 15.5578C39.6837 15.1984 39.2185 14.9977 38.735 15C38.2492 15 37.7885 15.2054 37.4563 15.5672L24 28.7302L10.5437 15.5672C10.2114 15.2054 9.75083 15 9.26503 15C8.78152 14.9977 8.31633 15.1984 7.98177 15.5578C7.64949 15.9149 7.47533 16.398 7.50283 16.8905C7.52803 17.3829 7.75261 17.8428 8.12384 18.1625L22.7898 32.4996C23.1747 32.8776 23.7087 33.055 24.2381 32.985L24.2386 32.9874Z" fill="white"/></svg></button>',
                    asNavFor: '.amenities-slider .slider-for',
                    responsive: [
                        {
                            breakpoint: 992,
                            settings: {
                                verticalSwiping: false,
                                vertical: false,
                                variableWidth: true
                            }
                        }
                    ]
                });


                $('.amenities-slider .slider-nav .slick-slide').click(function() {
                    var slideIndex = $(this).data('slick-index');
                    $('.amenities-slider .slider-nav').slick('slickGoTo', slideIndex);
                });
                
                setTimeout(function () {
                    if($('.amenities-slider .slider-nav .slick-slide').length >= 5){
                        $('.amenities-slider .slider-nav').slick('slickGoTo', 3);
                    }
                }, 500);
        


                $('.amenities-slider .slider-nav').on('beforeChange', function(event, slick, currentSlide, nextSlide) {

                    if ($(window).width() >= 992) {
                        $('.amenities-slider .slider-nav .slick-slide').removeClass('prev-1 prev-2 prev-3 next-1 next-2 next-3');

                        $('.slick-slide[data-slick-index="'+(nextSlide-1)+'"]').addClass('prev-1');
                        $('.slick-slide[data-slick-index="'+(nextSlide-2)+'"]').addClass('prev-2');
                        $('.slick-slide[data-slick-index="'+(nextSlide-3)+'"]').addClass('prev-3');
                        $('.slick-slide[data-slick-index="'+(nextSlide+1)+'"]').addClass('next-1');
                        $('.slick-slide[data-slick-index="'+(nextSlide+2)+'"]').addClass('next-2');
                        $('.slick-slide[data-slick-index="'+(nextSlide+3)+'"]').addClass('next-3');

                        setTimeout(function () {
                            $(this).closest('.amenities-slider').addClass('loaded');
                        }, 1000);
                    }
                });

            }


    

            if ($(".amenities-slider").length > 0) {
                $(".amenities-slider .slider-for").not('.slick-initialized').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    autoplaySpeed: false,
                    adaptiveHeight: true,
                    arrows: false,
                    fade: true,
                    cssEase: 'linear',
                    dots: false,
                    asNavFor: '.amenities-slider .slider-nav'
                });
            }

            $('.amenities-slider').addClass('loaded');

        });

        $(window).resize(function () {
            setTimeout(function () {
                $('.amenities-slider .slider-nav .slick-slide').click(function() {
                    var slideIndex = $(this).data('slick-index');
                    $('.amenities-slider .slider-nav').slick('slickGoTo', slideIndex);
                });
            }, 500);
        });

        if (typeof gform !== 'undefined') { 
            gform.addFilter( 'gform_datepicker_options_pre_init', function( optionsObj, formId, fieldId ) {
                optionsObj.changeMonth = false;
                optionsObj.changeYear = true;
                optionsObj.showOtherMonths = false;

                // set hard date format
                optionsObj.dateFormat = 'dd-mm-yy';

                if ( $("#input_"+formId+"_"+fieldId).length > 0 ) {
                    $("#input_"+formId+"_"+fieldId).datepicker('option', 'dateFormat', optionsObj.dateFormat);
                    $("#input_"+formId+"_"+fieldId).datepicker('option', 'changeYear', true);
                    $("#input_"+formId+"_"+fieldId).datepicker('option', 'yearRange', "-120:+20");
                }

                if ( $("#input_"+formId+"_"+fieldId).closest('.only-future').length > 0 ) {
                    optionsObj.minDate = 0;
                    $("#input_"+formId+"_"+fieldId).datepicker('option', 'minDate', new Date());
                    $("#input_"+formId+"_"+fieldId).datepicker('option', 'dateFormat', optionsObj.dateFormat);
                }

                if ( $("#input_"+formId+"_"+fieldId).closest('.only-past').length > 0 ) {
                    optionsObj.maxDate = 0;
                    $("#input_"+formId+"_"+fieldId).datepicker('option', 'maxDate', new Date());
                    $("#input_"+formId+"_"+fieldId).datepicker('option', 'dateFormat', optionsObj.dateFormat);
                }

                return optionsObj;
            });
        }




        var $slick_slider = $('.wrap-cities .cities');
        var settings = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            dots: false,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 9999,
                    settings: "unslick"
                },
                {
                    breakpoint: 768,
                    settings: {
                        variableWidth: true,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        $slick_slider.slick(settings);

        if ($(".testimonials-images__item").length > 0) {
            $(".testimonials-images__content--items").not('.slick-initialized').slick({
                slidesToShow: 1,
                infinite: true,
                arrows: false,
                dots: true,
                asNavFor: '.testimonials-images__images-wrapper'
            });
        }

        if ($(".testimonials-images__images-wrapper").length > 0) {
            $(".testimonials-images__images-wrapper").not('.slick-initialized').slick({
                slidesToShow: 1,
                infinite: true,
                autoplaySpeed: 3000,
                adaptiveHeight: true,
                arrows: false,
                dots: false,
                asNavFor: '.testimonials-images__content--items'
            });
        }

        if ($(".promotions__main").length > 0) {
            $(".promotions__main").not('.slick-initialized').slick({
                slidesToShow: 1,
                infinite: true,
                autoplay: true,
                autoplaySpeed: 3000,
                fade: true,
                arrows: false,
                asNavFor: '.promotions__cat--main'
            });
        }

        if ($(".promotions__cat--main").length > 0) {
            $(".promotions__cat--main").not('.slick-initialized').slick({
                slidesToShow: 3,
                arrows: false,
                asNavFor: '.promotions__main',
                focusOnSelect: true
            });
        }

        if ($(".testimonials__items").length > 0) {
            $(".testimonials__items").not('.slick-initialized').slick({
                slidesToShow: 1,
                arrows: false,
                dots: true,
            });
        }

        if ($(".home-banner__items").length > 0) {
            $(".home-banner__items").not('.slick-initialized').slick({
                slidesToShow: 1,
                arrows: false,
                dots: false,
                fade: true,
                speed: 300,
            });


            if ($(".home-banner__locations ul li").length > 0) {

                $(".home-banner__locations ul").hover(function () {
                }, function () {
                    $('.home-banner__items').slick('slickGoTo', 0);
                });

                $(document).on({
                    mouseenter: function () {
                        var index = $(this).index();
                        $('.home-banner__items').slick('slickGoTo', index);
                    }
                }, ".home-banner__locations ul li"); //pass the element as an argument to .on

            }

        }

        if ($(".city-banner__main").length > 0) {
            $(".city-banner__main").not('.slick-initialized').slick({
                slidesToShow: 1,
                arrows: false,
                dots: false
            });
        }

        if ($(".properties-banner__main").length > 0) {
            $(".properties-banner__main").not('.slick-initialized').slick({
                slidesToShow: 1,
                arrows: true,
                dots: false,
                adaptiveHeight: true,
                prevArrow: '<button type="button" class="slick-prev" style=""><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="25" cy="25" r="25" transform="rotate(-180 25 25)" fill="white"/><path d="M15.0108 24.7423C15.065 25.2732 15.2859 25.7758 15.6444 26.1796L25.249 37.032C25.7013 37.5791 26.3641 37.9243 27.0832 37.9889C27.8024 38.0535 28.5173 37.8335 29.0675 37.3793C29.6157 36.9231 29.9513 36.273 29.9951 35.5746C30.0389 34.8761 29.7887 34.1897 29.301 33.6729L21.1803 24.5L29.301 15.3271C29.7887 14.8103 30.0388 14.1239 29.9951 13.4254C29.9513 12.727 29.6157 12.0769 29.0675 11.6207C28.5173 11.1665 27.8024 10.9465 27.0832 11.0111C26.3641 11.0757 25.7014 11.4209 25.249 11.968L15.6444 22.8204C15.1734 23.3513 14.9462 24.0458 15.0108 24.7423Z" fill="#242A56"/></svg></button>',
                nextArrow: '<button type="button" class="slick-next" style=""><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="25.0009" cy="25" r="25" fill="white"/><path d="M34.9901 25.2577C34.9359 24.7268 34.7149 24.2242 34.3564 23.8204L24.7518 12.968C24.2995 12.4209 23.6367 12.0757 22.9176 12.0111C22.1985 11.9465 21.4836 12.1665 20.9333 12.6207C20.3851 13.0769 20.0496 13.727 20.0058 14.4254C19.962 15.1239 20.2121 15.8103 20.6999 16.3271L28.8205 25.5L20.6999 34.6729C20.2121 35.1897 19.962 35.8761 20.0058 36.5746C20.0495 37.273 20.3851 37.9231 20.9333 38.3793C21.4835 38.8335 22.1985 39.0535 22.9176 38.9889C23.6367 38.9243 24.2995 38.5791 24.7518 38.032L34.3564 27.1796C34.8275 26.6487 35.0547 25.9542 34.9901 25.2577Z" fill="#242A56"/></svg></button>'
            });
        }

        if ($(".city-building__main").length > 0) {

            var $city_building_slider = $('.city-building__main');

            var currentSlide;
            var slidesCount;
            var city_building_sliderCounter = document.createElement('div');
            city_building_sliderCounter.classList.add('city-building__main--slider__counter');

            var city_building_updateSliderCounter = function city_building_updateSliderCounter(slick, currentIndex) {
                currentSlide = slick.slickCurrentSlide() + 1;
                slidesCount = slick.slideCount;
                if (currentSlide < 10) {
                    currentSlide = "0" + currentSlide;
                }

                if (slidesCount < 10) {
                    slidesCount = "0" + slidesCount;
                }

                $(city_building_sliderCounter).html("<span>" + currentSlide + "</span>" + ' / ' + slidesCount);
            };
            $(".city-building").addClass('actived-slider');
            $city_building_slider.on('init', function (event, slick) {
                $city_building_slider.append(city_building_sliderCounter);
                city_building_updateSliderCounter(slick);
                var bg = $(".slick-current.slick-active").find(".city-building__item").data('bg');
                setTimeout(function () {
                    $(".city-building").css('background-image', 'url("' + bg + '")');
                }, 0);
            });

            $city_building_slider.on('beforeChange', function (event, slick, currentSlide) {
                city_building_updateSliderCounter(slick, currentSlide);
                var bg = $(".slick-current.slick-active").next().find(".city-building__item").data('bg');
                $(".city-building").css('background-image', 'url("' + bg + '")');

                $(".city-building").removeClass('actived-slider');
            });
            $city_building_slider.on('afterChange', function (event, slick, currentSlide) {
                city_building_updateSliderCounter(slick, currentSlide);
                var bg = $(".slick-current.slick-active").find(".city-building__item").data('bg');
                $(".city-building").css('background-image', 'url("' + bg + '")');

                $(".city-building").removeClass('actived-slider');
            });

            $city_building_slider.not('.slick-initialized').slick({
                infinite: true,
                centerMode: true,
                centerPadding: '20%',
                arrows: true,
                slidesToShow: 1,
                speed: 1000,
                touchMove: false,
                swipe: false,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            touchMove: true,
                            swipe: true,
                        }
                    }
                ]
            });

        }

        if ($(".play-scape__discover").length > 0) {
            var $slider = $('.play-scape__discover');

            if($(".play-scape__discover .play-scape__discover--item").length > 1){
                var currentSlide;
                var slidesCount;
                var sliderCounter = document.createElement('div');
                sliderCounter.classList.add('play-scape__discover__slider__counter');

                var updateSliderCounter = function updateSliderCounter(slick, currentIndex) {
                    currentSlide = slick.slickCurrentSlide() + 1;
                    slidesCount = slick.slideCount;
                    $(sliderCounter).text(currentSlide + '/' + slidesCount);
                };

                $slider.on('init', function (event, slick) {
                    $slider.append(sliderCounter);
                    updateSliderCounter(slick);
                });

                $slider.on('afterChange', function (event, slick, currentSlide) {
                    updateSliderCounter(slick, currentSlide);
                });
            }

            $slider.not('.slick-initialized').slick({
                slidesToShow: 1,
                adaptiveHeight: true,
                arrows: true,
                prevArrow: '<button type="button" class="slick-prev" style=""><svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M0.00980706 13.188C0.0533732 13.4769 0.184071 13.7441 0.38738 13.9535L11.5403 25.5085C11.789 25.801 12.1466 25.9779 12.5296 25.9978C12.9126 26.0194 13.2884 25.8822 13.5661 25.6204C13.8457 25.3568 14.0018 24.9903 14 24.6094C14 24.2266 13.8402 23.8637 13.5589 23.6019L3.32096 13L13.5589 2.39808C13.8402 2.13629 14 1.77338 14 1.39063C14.0018 1.00968 13.8457 0.643166 13.5661 0.379574C13.2884 0.117779 12.9127 -0.0194357 12.5296 0.00222793C12.1466 0.0220872 11.789 0.199022 11.5403 0.491512L0.389238 12.0465C0.0951677 12.3498 -0.0427939 12.7705 0.0116649 13.1876L0.00980706 13.188Z" fill="white"/>\n' + '</svg></button>',
                nextArrow: '<button type="button" class="slick-next" style="">' + '<svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M13.9902 12.812C13.9466 12.5231 13.8159 12.2559 13.6126 12.0465L2.4597 0.491509C2.21101 0.199025 1.8534 0.0221001 1.47039 0.00222555C1.08737 -0.0194401 0.711616 0.117775 0.433862 0.379569C0.154314 0.643166 -0.00180159 1.00968 1.60743e-05 1.39063C1.60363e-05 1.77339 0.159757 2.13629 0.441123 2.39808L10.679 13L0.441121 23.6019C0.159755 23.8637 1.38056e-05 24.2266 1.37676e-05 24.6094C-0.00180207 24.9903 0.154312 25.3568 0.433859 25.6204C0.711595 25.8822 1.08733 26.0194 1.47038 25.9978C1.8534 25.9779 2.21103 25.801 2.45969 25.5085L13.6108 13.9535C13.9048 13.6502 14.0428 13.2295 13.9883 12.8124L13.9902 12.812Z" fill="white"/>\n' + '</svg></button>'
            });
        }

        if ($(".city-about__video--main").length > 0) {
            var $slider = $('.city-about__video--main');

            var currentSlide;
            var slidesCount;
            var sliderCounter = document.createElement('div');
            sliderCounter.classList.add('city-about__video--main__slider__counter');

            var updateSliderCounter = function updateSliderCounter(slick, currentIndex) {
                currentSlide = slick.slickCurrentSlide() + 1;
                slidesCount = slick.slideCount;
                $(sliderCounter).text(currentSlide + '/' + slidesCount);
            };

            $slider.on('init', function (event, slick) {
                $slider.append(sliderCounter);
                updateSliderCounter(slick);
            });

            $slider.on('afterChange', function (event, slick, currentSlide) {
                updateSliderCounter(slick, currentSlide);
            });

            $slider.not('.slick-initialized').slick({
                slidesToShow: 1,
                arrows: true,
                prevArrow: '<button type="button" class="slick-prev" style=""><svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M0.00980706 13.188C0.0533732 13.4769 0.184071 13.7441 0.38738 13.9535L11.5403 25.5085C11.789 25.801 12.1466 25.9779 12.5296 25.9978C12.9126 26.0194 13.2884 25.8822 13.5661 25.6204C13.8457 25.3568 14.0018 24.9903 14 24.6094C14 24.2266 13.8402 23.8637 13.5589 23.6019L3.32096 13L13.5589 2.39808C13.8402 2.13629 14 1.77338 14 1.39063C14.0018 1.00968 13.8457 0.643166 13.5661 0.379574C13.2884 0.117779 12.9127 -0.0194357 12.5296 0.00222793C12.1466 0.0220872 11.789 0.199022 11.5403 0.491512L0.389238 12.0465C0.0951677 12.3498 -0.0427939 12.7705 0.0116649 13.1876L0.00980706 13.188Z" fill="white"/>\n' + '</svg></button>',
                nextArrow: '<button type="button" class="slick-next" style="">' + '<svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M13.9902 12.812C13.9466 12.5231 13.8159 12.2559 13.6126 12.0465L2.4597 0.491509C2.21101 0.199025 1.8534 0.0221001 1.47039 0.00222555C1.08737 -0.0194401 0.711616 0.117775 0.433862 0.379569C0.154314 0.643166 -0.00180159 1.00968 1.60743e-05 1.39063C1.60363e-05 1.77339 0.159757 2.13629 0.441123 2.39808L10.679 13L0.441121 23.6019C0.159755 23.8637 1.38056e-05 24.2266 1.37676e-05 24.6094C-0.00180207 24.9903 0.154312 25.3568 0.433859 25.6204C0.711595 25.8822 1.08733 26.0194 1.47038 25.9978C1.8534 25.9779 2.21103 25.801 2.45969 25.5085L13.6108 13.9535C13.9048 13.6502 14.0428 13.2295 13.9883 12.8124L13.9902 12.812Z" fill="white"/>\n' + '</svg></button>'
            });
        }

        if ($(".footer__top--main").length && $(window).width() < 768) {
            $(".footer__top--main>ul>li>a").click(function (e) {
                e.preventDefault();
                $(this).toggleClass('active');
                $(this).parent().find('ul').toggleClass('active');
            });
        }

        $(".room-gallary-popup-button").fancybox({
            closeExisting: true,
            arrows: false,
            btnTpl: {
                arrowLeft: "",
                arrowRight: ""
            },
            afterLoad: function( instance, current) {
                var nth = $(current.opts.$orig).data('nth');
                if ($(".room-gallery-fancy__main").length > 0) {
                    $(".room-gallery-fancy__main").not('.slick-initialized').slick({
                        slidesToShow: 1,
                        arrows: true,
                        infinite: true,
                        fade:true,
                        adaptiveHeight: true,
                        prevArrow: '<button type="button" class="slick-prev" style=""><svg width="15" height="27" viewBox="0 0 15 27" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M0.010795 13.7423C0.0649866 14.2732 0.285926 14.7758 0.644433 15.1796L10.249 26.032C10.7013 26.5791 11.3641 26.9243 12.0832 26.9889C12.8024 27.0535 13.5173 26.8335 14.0675 26.3793C14.6157 25.9231 14.9513 25.273 14.9951 24.5746C15.0389 23.8761 14.7887 23.1897 14.301 22.6729L6.18031 13.5L14.301 4.32706C14.7887 3.81027 15.0388 3.12393 14.9951 2.42544C14.9513 1.72695 14.6157 1.07694 14.0675 0.620722C13.5173 0.166514 12.8024 -0.0535282 12.0832 0.01107C11.3641 0.0756682 10.7014 0.420866 10.249 0.96795L0.644433 11.8204C0.173376 12.3513 -0.0538221 13.0458 0.010795 13.7423Z" fill="#242A56"/>\n' + '</svg></button>',
                        nextArrow: '<button type="button" class="slick-next" style=""><svg width="15" height="27" viewBox="0 0 15 27" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M14.9892 13.2577C14.935 12.7268 14.7141 12.2242 14.3556 11.8204L4.75097 0.967951C4.29867 0.420881 3.63588 0.0756682 2.91676 0.0110701C2.19764 -0.0535279 1.48274 0.16651 0.932449 0.620724C0.384293 1.07695 0.0487193 1.72695 0.00491168 2.42544C-0.0388591 3.12393 0.211261 3.81027 0.699004 4.32706L8.81969 13.5L0.699005 22.6729C0.211273 23.1897 -0.0388416 23.8761 0.00491265 24.5746C0.0486835 25.273 0.384262 25.9231 0.93245 26.3793C1.48269 26.8335 2.19764 27.0535 2.91676 26.9889C3.63588 26.9243 4.29865 26.5791 4.75097 26.032L14.3556 15.1796C14.8266 14.6487 15.0538 13.9542 14.9892 13.2577Z" fill="#242A56"/>\n' + '</svg></button>'
                    });
                }
                $('.room-gallery-fancy__main').slick('refresh');
                setTimeout(function () {
                    $(current.src+" .room-gallery-fancy__main").slick('slickGoTo', nth);
                }, 500);

                setTimeout(function () {
                    $('.room-gallery-fancy__main').slick('refresh');
                }, 1000);
            }
        });

        $(".room-virtual-tour-popup-button").fancybox({
            closeExisting: true,
            arrows: false,
            btnTpl: {
                arrowLeft: "",
                arrowRight: ""
            },
        });

    

        $(".room-floorlan-popup-button").fancybox({
            closeExisting: true,
            arrows: false,
            btnTpl: {
                arrowLeft: "",
                arrowRight: ""
            },
            afterLoad: function afterLoad() {
                if ($(".room-floorlan-fancy__main").length > 0) {
                    $(".room-floorlan-fancy__main").not('.slick-initialized').slick({
                        slidesToShow: 1,
                        arrows: true,
                        infinite: true,
                        prevArrow: '<button type="button" class="slick-prev" style=""><svg width="15" height="27" viewBox="0 0 15 27" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M0.010795 13.7423C0.0649866 14.2732 0.285926 14.7758 0.644433 15.1796L10.249 26.032C10.7013 26.5791 11.3641 26.9243 12.0832 26.9889C12.8024 27.0535 13.5173 26.8335 14.0675 26.3793C14.6157 25.9231 14.9513 25.273 14.9951 24.5746C15.0389 23.8761 14.7887 23.1897 14.301 22.6729L6.18031 13.5L14.301 4.32706C14.7887 3.81027 15.0388 3.12393 14.9951 2.42544C14.9513 1.72695 14.6157 1.07694 14.0675 0.620722C13.5173 0.166514 12.8024 -0.0535282 12.0832 0.01107C11.3641 0.0756682 10.7014 0.420866 10.249 0.96795L0.644433 11.8204C0.173376 12.3513 -0.0538221 13.0458 0.010795 13.7423Z" fill="#242A56"/>\n' + '</svg></button>',
                        nextArrow: '<button type="button" class="slick-next" style=""><svg width="15" height="27" viewBox="0 0 15 27" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M14.9892 13.2577C14.935 12.7268 14.7141 12.2242 14.3556 11.8204L4.75097 0.967951C4.29867 0.420881 3.63588 0.0756682 2.91676 0.0110701C2.19764 -0.0535279 1.48274 0.16651 0.932449 0.620724C0.384293 1.07695 0.0487193 1.72695 0.00491168 2.42544C-0.0388591 3.12393 0.211261 3.81027 0.699004 4.32706L8.81969 13.5L0.699005 22.6729C0.211273 23.1897 -0.0388416 23.8761 0.00491265 24.5746C0.0486835 25.273 0.384262 25.9231 0.93245 26.3793C1.48269 26.8335 2.19764 27.0535 2.91676 26.9889C3.63588 26.9243 4.29865 26.5791 4.75097 26.032L14.3556 15.1796C14.8266 14.6487 15.0538 13.9542 14.9892 13.2577Z" fill="#242A56"/>\n' + '</svg></button>'
                    });
                }
            }
        });

        if ($(".promotions__main").length > 0) {
            $(".promotions__main").not('.slick-initialized').slick({
                slidesToShow: 1,
                infinite: true,
                autoplay: true,
                autoplaySpeed: 3000,
                fade: true,
                arrows: false,
                asNavFor: '.promotions__cat--main'
            });
        }

        if ($(".promotions__cat--main").length > 0) {
            $(".promotions__cat--main").not('.slick-initialized').slick({
                slidesToShow: 3,
                arrows: false,
                asNavFor: '.promotions__main',
                focusOnSelect: true
            });
        }

        if ($(".home-banner__items").length > 0) {
            $(".home-banner__items").not('.slick-initialized').slick({
                slidesToShow: 1,
                arrows: false,
                dots: false,
                fade: true
            });

            if ($(".home-banner__locations ul li").length > 0) {
                $(".home-banner__locations ul li").hover(function () {
                    var index = $(this).index();
                    $('.home-banner__items').slick('slickGoTo', index);
                });
            }
        }

        $('.header__main--menu > ul > li#page-locations > a').on('click', function (e) {
            $('body').addClass('mega-open-mobile');
        });


        $('.menu_mega .menu_mega__item').on('click', function (e) {
            e.preventDefault();
            if(e.target.tagName.toLowerCase() === 'a'){
                window.location.replace(e.target.href);
            }
            $('.menu_mega .menu_mega__item').removeClass('active');
            $('.menu_mega .menu_mega-right__item').removeClass('active');
            $(this).addClass('active');
            var data_sub = $(this).data('sub');
            
            $("#"+data_sub).addClass('active');

            // var data_bg = $(this).data('bg');
            // var image = $(this).closest('.left-content');
            // image.fadeTo("slow", 0.3, function(){
            //     $(this).css('background-image', 'url(' + data_bg + ')');
            // }).fadeTo("slow", 1);
 
            $('body').addClass('mega-open-properties-mobile');
        });

        $('.back-to-city').on('click', function (e) {
            $('body').removeClass('mega-open-properties-mobile');
        });

        $('.back-to-main-mega').on('click', function (e) {
            $('body').removeClass('mega-open-mobile');
        });

        var propertiesRelatedSlider = function propertiesRelatedSlider() {
            if ($(".properties-explore__main").length > 0) {
                var item_count = $(".properties-explore__main .properties-explore__item").length;
                if ($(window).width() > 1440 && item_count < 4) {
                    $(".properties-explore__main").addClass('not-enough');
                }

                $(".properties-explore__main").not('.slick-initialized').slick({
                    centerMode: true,
                    centerPadding: '30px',
                    arrows: true,
                    slidesToShow: 3,
                    adaptiveHeight: true,
                    responsive: [
                        {
                            breakpoint: 1650,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ],
                    prevArrow: '<button type="button" class="slick-prev" style="" aria-label="prev"><svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M0.00980706 13.188C0.0533732 13.4769 0.184071 13.7441 0.38738 13.9535L11.5403 25.5085C11.789 25.801 12.1466 25.9779 12.5296 25.9978C12.9126 26.0194 13.2884 25.8822 13.5661 25.6204C13.8457 25.3568 14.0018 24.9903 14 24.6094C14 24.2266 13.8402 23.8637 13.5589 23.6019L3.32096 13L13.5589 2.39808C13.8402 2.13629 14 1.77338 14 1.39063C14.0018 1.00968 13.8457 0.643166 13.5661 0.379574C13.2884 0.117779 12.9127 -0.0194357 12.5296 0.00222793C12.1466 0.0220872 11.789 0.199022 11.5403 0.491512L0.389238 12.0465C0.0951677 12.3498 -0.0427939 12.7705 0.0116649 13.1876L0.00980706 13.188Z" fill="white"/>\n' + '</svg></button>',
                    nextArrow: '<button type="button" class="slick-next" style="" aria-label="next"><svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M13.9902 12.812C13.9466 12.5231 13.8159 12.2559 13.6126 12.0465L2.4597 0.491509C2.211 0.199025 1.8534 0.0221001 1.47039 0.00222555C1.08737 -0.0194401 0.711616 0.117775 0.433862 0.379569C0.154314 0.643166 -0.00180131 1.00968 1.56471e-05 1.39063C1.56091e-05 1.77339 0.159757 2.13629 0.441122 2.39808L10.679 13L0.44112 23.6019C0.159755 23.8637 1.33784e-05 24.2266 1.33404e-05 24.6094C-0.00180184 24.9903 0.154311 25.3568 0.433859 25.6204C0.711595 25.8822 1.08733 26.0194 1.47038 25.9978C1.8534 25.9779 2.21103 25.801 2.45969 25.5085L13.6108 13.9535C13.9048 13.6502 14.0428 13.2295 13.9883 12.8124L13.9902 12.812Z" fill="white"/>\n' + '</svg></button>',
                });

                $('.properties-explore__main').on('beforeChange', function (event, {slideCount: count}, currentSlide, nextSlide) {
                    if (currentSlide == 0) {
                        $('.properties-explore__main').addClass('active');
                    }
                });
            }
        };

        propertiesRelatedSlider();


        var options = {
            horizontal: 1,
            itemNav: 'forceCentered',
            speed: 500,
            activateMiddle: false,
            activatePageOn: 'click',
            smart: 1,
            startAt: 0,
            mouseDragging: 1,
            activateOn: 'click',
            touchDragging: 1
        };

        if ($("#frame").length > 0) {
            var frameSly = new Sly('#frame', options).init();
        }

        $(window).resize(function () {
            
            if($(window).width() > 992){
                $("body").removeClass('open-menu');
            }
        });


        var optionsRoomItems = {
            centerMode: false,
            slidesToShow: 1,
            speed: 500,
            swipeToSlide: true,
            infinite: false,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev pull-left" aria-label="prev"><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="25" cy="25" r="25" transform="rotate(-180 25 25)" fill="white"/><path d="M15.0108 24.7423C15.065 25.2732 15.2859 25.7758 15.6444 26.1796L25.249 37.032C25.7013 37.5791 26.3641 37.9243 27.0832 37.9889C27.8024 38.0535 28.5173 37.8335 29.0675 37.3793C29.6157 36.9231 29.9513 36.273 29.9951 35.5746C30.0389 34.8761 29.7887 34.1897 29.301 33.6729L21.1803 24.5L29.301 15.3271C29.7887 14.8103 30.0388 14.1239 29.9951 13.4254C29.9513 12.727 29.6157 12.0769 29.0675 11.6207C28.5173 11.1665 27.8024 10.9465 27.0832 11.0111C26.3641 11.0757 25.7014 11.4209 25.249 11.968L15.6444 22.8204C15.1734 23.3513 14.9462 24.0458 15.0108 24.7423Z" fill="#242A56"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next pull-right" aria-label="next"><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="25.0009" cy="25" r="25" fill="white"/><path d="M34.9901 25.2577C34.9359 24.7268 34.7149 24.2242 34.3564 23.8204L24.7518 12.968C24.2995 12.4209 23.6367 12.0757 22.9176 12.0111C22.1985 11.9465 21.4836 12.1665 20.9333 12.6207C20.3851 13.0769 20.0496 13.727 20.0058 14.4254C19.962 15.1239 20.2121 15.8103 20.6999 16.3271L28.8205 25.5L20.6999 34.6729C20.2121 35.1897 19.962 35.8761 20.0058 36.5746C20.0495 37.273 20.3851 37.9231 20.9333 38.3793C21.4835 38.8335 22.1985 39.0535 22.9176 38.9889C23.6367 38.9243 24.2995 38.5791 24.7518 38.032L34.3564 27.1796C34.8275 26.6487 35.0547 25.9542 34.9901 25.2577Z" fill="#242A56"/></svg></button>\n',
            // asNavFor: '.properties-room-detail--tabs--items'
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        prevArrow: '<button type="button" class="slick-prev pull-left" aria-label="prev"><svg width="55" height="55" viewBox="0 0 55 55" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="27.5" cy="27.5" r="27" fill="white" stroke="#BEBEBE"/><path d="M18.3427 28.1639C18.3848 28.4427 18.5109 28.7005 18.707 28.9026L29.4686 40.0521C29.7086 40.3343 30.0537 40.505 30.4232 40.5242C30.7928 40.5451 31.1554 40.4127 31.4234 40.1601C31.6931 39.9058 31.8438 39.5521 31.842 39.1845C31.842 38.8152 31.6879 38.465 31.4164 38.2124L21.5377 27.9825L31.4164 17.7526C31.6879 17.5 31.842 17.1498 31.842 16.7805C31.8438 16.4129 31.6931 16.0592 31.4234 15.8049C31.1554 15.5523 30.7928 15.4199 30.4232 15.4408C30.0537 15.46 29.7086 15.6307 29.4686 15.9129L18.7088 27.0624C18.4251 27.3551 18.292 27.761 18.3445 28.1635L18.3427 28.1639Z" fill="#FA70A8"/></svg></button>',
                        nextArrow: '<button type="button" class="slick-next pull-right" aria-label="next"><svg width="55" height="55" viewBox="0 0 55 55" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="27.5" cy="27.5" r="27" transform="rotate(-180 27.5 27.5)" fill="white" stroke="#BEBEBE"/><path d="M36.6573 26.8361C36.6152 26.5573 36.4891 26.2995 36.293 26.0974L25.5314 14.9479C25.2914 14.6657 24.9463 14.495 24.5768 14.4758C24.2072 14.4549 23.8446 14.5873 23.5766 14.8399C23.3069 15.0942 23.1562 15.4479 23.158 15.8155C23.158 16.1848 23.3121 16.535 23.5836 16.7876L33.4623 27.0175L23.5836 37.2474C23.3121 37.5 23.158 37.8502 23.158 38.2195C23.1562 38.5871 23.3069 38.9408 23.5766 39.1951C23.8446 39.4477 24.2072 39.5801 24.5768 39.5592C24.9463 39.54 25.2914 39.3693 25.5314 39.0871L36.2912 27.9376C36.5749 27.6449 36.708 27.239 36.6555 26.8365L36.6573 26.8361Z" fill="#FA70A8"/></svg></button>\n'
                    }
                }
            ],
        };

        if ($(".properties-room-detail--items").length > 0) {
            $(".properties-room-detail--items").not('.slick-initialized').slick(optionsRoomItems);
        }

        $('.properties-room-detail--tabs--items .properties-room-detail--tabs--item').on('click', function (e) {
            e.preventDefault();
            var $wrap = $(this).closest(".properties-room-detail--tabs");
            $wrap.addClass("overlay-on");
            var $room_id = $(this).data('room-id');
            var index = $('.properties-room-detail--items').find(".room-id-" + $room_id).closest(".slick-slide").data("slick-index");
            $('.properties-room-detail--items').slick('slickGoTo', index);

            setTimeout(function () {
                $wrap.removeClass("overlay-on");
            }, 500);
        });


        $(".properties-room-detail--items").on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            var $room_id = $(".properties-room-detail--items .slick-slide[data-slick-index=" + nextSlide + "]").find(".properties-room-detail--item").data("room-id");
            if ($("#frame").length > 0) {
                frameSly.activate(nextSlide);
            }
        });

        $(".filter-cats").mCustomScrollbar({
            axis: "x",
            advanced: {
                autoExpandHorizontalScroll: true
            }
        });

        if ($("body.single-post main").length > 0) {
            var cont = $("body.single-post main").html();
            cont = cont.replace(/<[^>]*>/g, " ");
            cont = cont.replace(/\s+/g, ' ');
            cont = cont.trim();
            var $readtime = cont.split(" ").length / 200;
            var $postfix = '';
            var $readingtime = '';

            if ($readtime < 1) $readtime = 1;
            if ($readtime == 1) {
                $postfix = " min read";
            } else {
                $postfix = " mins read";
            }

            $readingtime = Math.round($readtime) + $postfix;
            $(".top-content .read-time span").text($readingtime);
        }

        $(".filter-cats").mCustomScrollbar({
            axis:"x",
            autoExpandScrollbar: true,
            autoDraggerLength:true,
            autoHideScrollbar: true,
        });

        setTimeout(function () {
            var cats = $('.filter-cats ul li');
            var post_width = 0;
            var pos_scroll = 0;
            $(cats).each(function () {
                var width = $(this).width();
                if ($(this).hasClass('active')){
                    pos_scroll = post_width;
                    console.log(pos_scroll);
                }
                post_width += (width);
            });

            $('.filter-cats').mCustomScrollbar("scrollTo", pos_scroll);
        }, 1000);


        if ($(".image-text-with-white__item").length > 0) {
            $(".image-text-with-white__main").not('.slick-initialized').slick({
                slidesToShow: 1,
                arrows: false,
                dots: false,
                responsive: [{
                    breakpoint: 9999,
                    settings: 'unslick'
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                }]
            });
        }

        var dateToday = new Date();
        $(".datepicker").datepicker({
            dateFormat: 'yy-mm-dd'
        });

        $("a.popup").fancybox({
            closeExisting: true,
            loop: true,
            padding: 0,
            helpers: {
                overlay: {
                    locked: false
                }
            }
        });

        var svgConvert = function () {
            /*
            * Replace all SVG images with inline SVG
            */
            jQuery('img:not(.vision-ic):not(.inclusion-icon)').each(function () {
                var $img = jQuery(this);
                var imgID = $img.attr('id');
                var imgClass = $img.attr('class');
                var imgURL = $img.attr('src');

                jQuery.get(imgURL, function (data) {
                    // Get the SVG tag, ignore the rest
                    var $svg = jQuery(data).find('svg');

                    // Add replaced image's ID to the new SVG
                    if (typeof imgID !== 'undefined') {
                        $svg = $svg.attr('id', imgID);
                    }
                    // Add replaced image's classes to the new SVG
                    if (typeof imgClass !== 'undefined') {
                        $svg = $svg.attr('class', imgClass + ' replaced-svg');
                    }

                    // Remove any invalid XML tags as per http://validator.w3.org
                    $svg = $svg.removeAttr('xmlns:a');

                    // Replace image with new SVG
                    $img.replaceWith($svg);
                }, 'xml');
            });
        };

        svgConvert();

        function custom_template(obj) {

            var data = $(obj.element).data();

            var text = $(obj.element).text();
            if (data && data.img_src) {
                var img_src = data.img_src;
                var template = $("<div><img src=\"" + img_src + "\" />" + text + "</div>");
                return template;
            }
        }

        var options = {
            'templateSelection': custom_template,
            'templateResult': custom_template,
            'minimumResultsForSearch': -1
        };

        $('.country_option select').select2(options);

        $(".properties-menu--main .properties-menu--content ul li a").click(function (e) {

            e.preventDefault();
            var currentHref = $(this).attr('href');
            var currentTop = $(currentHref).offset().top;
            var body = $("html, body");
            if (currentHref == '#properties') {
                body.stop().animate({scrollTop: currentTop - 50}, 500, 'swing');
            } else if (currentHref == '#about') {
                body.stop().animate({scrollTop: currentTop - 130}, 500, 'swing');
            } else if (currentHref == '#around') {
                body.stop().animate({scrollTop: currentTop - 100}, 500, 'swing');
            } else if (currentHref == '#properties-rooms') {
                body.stop().animate({scrollTop: currentTop - 100}, 500, 'swing');
                if ( $(window).width() < 768) {
                    body.stop().animate({scrollTop: currentTop - 120}, 500, 'swing');
                }
            } else if (currentHref == '#properties-included') {
                body.stop().animate({scrollTop: currentTop - 100}, 500, 'swing');
                if ( $(window).width() < 768) {
                    body.stop().animate({scrollTop: currentTop - 50}, 500, 'swing');
                }
            } else if (currentHref == '#properties-features') {
                body.stop().animate({scrollTop: currentTop - 100}, 500, 'swing');

            } else if (currentHref == '#properties-around') {
                body.stop().animate({scrollTop: currentTop - 100}, 500, 'swing');
            } else if ($("body.single-university").length) {
                if ( $(window).width() > 768) {
                    body.stop().animate({scrollTop: currentTop - 40}, 500, 'swing');
                }else{
                    body.stop().animate({scrollTop: currentTop - 60}, 500, 'swing');
                }
            } else {
                if ($(window).width() > 768) {
                    body.stop().animate({scrollTop: currentTop - 0}, 500, 'swing');
                }else{
                    console.log(currentTop);
                    body.stop().animate({scrollTop: currentTop - 70}, 500, 'swing');
                    body.stop().animate({scrollTop: currentTop - 70}, 500, 'swing');
                }
            }

            var $label = $(this).text();
            $(this).closest(".properties-menu--content").find(".dropdown-mobile label").text($label);
            $(".properties-menu--main").find(".properties-menu--content").removeClass("dropdown-open");
        });

        if ($(".properties-menu").length) {
            var menubarTop = $(".properties-menu").offset().top;
        }

        $(window).scroll(function () {
            if (menubarTop) {
                var scrollTop = $(window).scrollTop();

                if (scrollTop > menubarTop) {
                    $(".properties-menu").addClass('fixed');
                } else {
                    $(".properties-menu").removeClass('fixed');
                }
            }

            var menuTabs = $(".properties-menu--main .properties-menu--content ul li");
            if (menuTabs.length > 0) {
                menuTabs.each(function (index) {
                    var currentHref = $(this).find('a').attr('href');

        
                    
                    if(currentHref == '#'){
                        return;
                    }



                    var nextHref = $(this).next().find('a').attr('href');
                    if (scrollTop > $(currentHref).offset().top - 150) {
                        if (nextHref === undefined || nextHref !== undefined && scrollTop < $(nextHref).offset().top) {
                            if (!$(this).hasClass('active')) {
                                $(".properties-menu--main .properties-menu--content ul li").removeClass('active');
                                $(this).addClass('active');
                            }
                            if ($(window).width() < 576) {
                                var $label = $(this).find('a').text();
                                $(this).closest(".properties-menu--content").find(".dropdown-mobile label").text($label);
                            }
                        }
                    }
                });
            }
            if ($(window).width() > 768) {
                scrollMenu();
            }
        }); 
        var lastS;
        var smallScreen;
        smallScreen = $(window).width() < 768 ? true : false;

        function scrollMenu() {
            var scrollPosT = $(window).scrollTop();
            var scrollPos = scrollPosT + $(window).height();

            lastS = scrollPosT;
            $('.parallax1').each(function () {
                var pIn = $(this).parent().offset().top;
                var pOut = pIn + $(this).parent().height() + (scrollPos - scrollPosT);

                if (pIn <= scrollPos + $(window).height() * 0.33 && pOut >= scrollPos) {
                    var mD = parseInt($(this).attr('data-para-dir'));
                    var mF = mD ? 1 / (pOut - pIn) * (scrollPos - pIn) : 1 - 1 / (pOut - pIn) * (scrollPos - pIn);
                    var mA = 0;
                    if (smallScreen && $(this).attr('data-para-mobile-amount')) {
                        mA = parseInt($(this).attr('data-para-mobile-amount'));
                    } else {
                        mA = parseInt($(this).attr('data-para-amount'));
                    }
                    if (!$(this).hasClass('center')) {
                        $(this).css('transform', 'translateY(' + mA * mF + '%)');
                    } else {
                        $(this).css('transform', 'translate(-50%,' + mA * mF + '%)');
                    }
                }
            });
        }

        // $(".footer__info .footer__menu--location>ul>li>a").click(function (e) {
        //     e.preventDefault();
        //     $(this).toggleClass('active').parent().find('ul').slideToggle();
        // });

        $(".footer__middle .footer__menu--location>ul>li>a.trigger-pro-list").click(function (e) {
            if($(window).width() < 768){            
                e.preventDefault();
                $(this).toggleClass('active').parent().find('ul.pro-list').slideToggle();
            }
        });

        $(".footer__middle .footer__menu--location>ul>li>a.trigger-uni-list").click(function (e) {
            if($(window).width() < 768){    
                e.preventDefault();
                $(this).toggleClass('active').parent().find('ul.uni-list').slideToggle();
            }
        });

        $(".properties-menu .properties-menu--content .dropdown-mobile").click(function (e) {
            e.preventDefault();
            $(this).closest(".properties-menu--main").find(".properties-menu--content").toggleClass("dropdown-open");
        });

        var roomMoreLength = 0;
        if ($(".room-list__main .room__item").length > 0) {
            roomMoreLength = $(".room-list__main .room__item").length;
        }

        mobileSlider();

        function mobileSlider() {
            var smallScreen990 = $(window).width() >= 991 ? true : false;

            // if ($(".home-banner__locations").length > 0) {
            //     $(".home-banner__locations ul").not('.slick-initialized').slick({
            //         slidesToShow: 1,
            //         arrows: true,
            //         dots: false,
            //         asNavFor: '.home-banner__items',
            //         responsive: [{
            //             breakpoint: 9999,
            //             settings: 'unslick'
            //         }, {
            //             breakpoint: 992,
            //             settings: {
            //                 slidesToShow: 1
            //             }
            //         }],
            //         prevArrow: '<button type="button" class="slick-prev" style=""><svg width="17" height="32" viewBox="0 0 17 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M16 31L0.999999 16L16 1" stroke="white"/>\n' + '</svg></button>',
            //         nextArrow: '<button type="button" class="slick-next" style=""><svg width="17" height="32" viewBox="0 0 17 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M1 1L16 16L1 31" stroke="white"/>\n' + '</svg></button>'
            //     });
            // }

            if ($(".room-gallery__main").length) {
                if (smallScreen990 == true) {
                    // if ($(".room-gallery.mobile .room-gallery__main").hasClass('slick-initialized')) {
                    //     $(".room-gallery.mobile .room-gallery__main").slick("unslick");
                    // }
                    $(".room-gallery.desktop .room-gallery__main").not('.slick-initialized').slick({
                        slidesToShow: 3,
                        arrows: false,
                        speed: 800,
                        lop: true,
                        cssEase: 'ease-in-out',
                        autoplay: true,
                        responsive: [{
                            breakpoint: 9999,
                            settings: 'unslick'
                        }, {
                            breakpoint: 1200,
                            centerMode: true,
                            centerPadding: '20%',
                            settings: {
                                slidesToShow: 3
                            }
                        }, {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 3
                            }
                        }, {
                            breakpoint: 900,
                            settings: {
                                slidesToShow: 2
                            }
                        }, {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1
                            }
                        }]
                    });
                } else {
                    // if($(".room-gallery.desktop .room-gallery__main").hasClass('slick-initialized')) {
                    //     $(".room-gallery.desktop .room-gallery__main").slick("unslick");
                    // }
                    $(".room-gallery.mobile .room-gallery__main").not('.slick-initialized').slick({
                        slidesToShow: 3,
                        arrows: false,
                        speed: 800,
                        lop: true,
                        cssEase: 'ease-in-out',
                        autoplay: true,
                        responsive: [{
                            breakpoint: 9999,
                            settings: 'unslick'
                        }, {
                            breakpoint: 1200,
                            centerMode: true,
                            centerPadding: '20%',
                            settings: {
                                slidesToShow: 3
                            }
                        }, {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 3
                            }
                        }, {
                            breakpoint: 900,
                            settings: {
                                slidesToShow: 2
                            }
                        }, {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1
                            }
                        }]
                    });
                }
            }

            if (roomMoreLength > 0) {

                if (roomMoreLength < 4) {
                    if ($(window).width() > 1295) {
                        if (!$(".room-list__main").hasClass('not-enough')) {
                            $(".room-list__main").addClass('not-enough');
                        }
                    } else {
                        if ($(".room-list__main").hasClass('not-enough')) {
                            $(".room-list__main").removeClass('not-enough');
                        }
                    }
                }

                $(".room-list__main").not('.slick-initialized').slick({
                    slidesToShow: 3,
                    arrows: true,
                    dots: false,
                    prevArrow: '<button type="button" class="slick-prev" style=""><svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M0.00980706 13.188C0.0533732 13.4769 0.184071 13.7441 0.38738 13.9535L11.5403 25.5085C11.789 25.801 12.1466 25.9779 12.5296 25.9978C12.9126 26.0194 13.2884 25.8822 13.5661 25.6204C13.8457 25.3568 14.0018 24.9903 14 24.6094C14 24.2266 13.8402 23.8637 13.5589 23.6019L3.32096 13L13.5589 2.39808C13.8402 2.13629 14 1.77338 14 1.39063C14.0018 1.00968 13.8457 0.643166 13.5661 0.379574C13.2884 0.117779 12.9127 -0.0194357 12.5296 0.00222793C12.1466 0.0220872 11.789 0.199022 11.5403 0.491512L0.389238 12.0465C0.0951677 12.3498 -0.0427939 12.7705 0.0116649 13.1876L0.00980706 13.188Z" fill="white"/>\n' + '</svg></button>',
                    nextArrow: '<button type="button" class="slick-next" style=""><svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M13.9902 12.812C13.9466 12.5231 13.8159 12.2559 13.6126 12.0465L2.4597 0.491509C2.211 0.199025 1.8534 0.0221001 1.47039 0.00222555C1.08737 -0.0194401 0.711616 0.117775 0.433862 0.379569C0.154314 0.643166 -0.00180131 1.00968 1.56471e-05 1.39063C1.56091e-05 1.77339 0.159757 2.13629 0.441122 2.39808L10.679 13L0.44112 23.6019C0.159755 23.8637 1.33784e-05 24.2266 1.33404e-05 24.6094C-0.00180184 24.9903 0.154311 25.3568 0.433859 25.6204C0.711595 25.8822 1.08733 26.0194 1.47038 25.9978C1.8534 25.9779 2.21103 25.801 2.45969 25.5085L13.6108 13.9535C13.9048 13.6502 14.0428 13.2295 13.9883 12.8124L13.9902 12.812Z" fill="white"/>\n' + '</svg></button>',
                    responsive: [{
                        breakpoint: 1600,
                        centerMode: true,
                        centerPadding: '20%',
                        settings: {
                            slidesToShow: 2,
                            variableWidth: true
                        }
                    }, {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 1,
                            variableWidth: true
                        }
                    }]
                });

                $('.room-list__main').on('beforeChange', function (event, {slideCount: count}, currentSlide, nextSlide) {

                
                });
                $(window).resize(function () {
                    $('.room-list__main').not('.slick-initialized').slick('refresh');
                });
            }

            if ($(".live-scape__locations > .live-scape__location").length && $(window).width() < 992) {
                $(".live-scape__locations").not('.slick-initialized').slick({
                    slidesToShow: 4,
                    arrows: false,
                    responsive: [{
                        breakpoint: 9999,
                        settings: "unslick"
                    }, {
                        breakpoint: 992,
                        centerMode: true,
                        centerPadding: '20%',
                        settings: {
                            slidesToShow: 2
                        }
                    }, {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1
                        }
                    }]
                });
            }

            if ($(".locations-block__locations > .locations-block__location").length && $(window).width() < 992) {
                $(".locations-block__locations").not('.slick-initialized').slick({
                    slidesToShow: 4,
                    arrows: false,
                    responsive: [{
                        breakpoint: 9999,
                        settings: "unslick"
                    }, {
                        breakpoint: 992,
                        centerMode: true,
                        centerPadding: '20%',
                        settings: {
                            slidesToShow: 2
                        }
                    }, {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1
                        }
                    }]
                });
            }

            if ($(".play-scape__main > .play-scape__item").length && $(window).width() < 992) {
                $(".play-scape__main").not('.slick-initialized').slick({
                    slidesToShow: 4,
                    arrows: false,
                    infinite: false,
                    responsive: [{
                        breakpoint: 992,
                        centerMode: true,
                        centerPadding: '20%',
                        settings: {
                            slidesToShow: 3
                        }
                    }, {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1
                        }
                    }]
                });
            }

            if ($(".city-news__main > .news__item").length && $(window).width() < 768) {
                $(".city-news__main").not('.slick-initialized').slick({
                    slidesToShow: 3,
                    arrows: false,
                    responsive: [{
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1
                        }
                    }]
                });
            }

            if ($(".properties-cover__main > .properties-cover__item").length && $(window).width() < 992) {
                $(".properties-cover__main").not('.slick-initialized').slick({
                    slidesToShow: 3,
                    dots: true,
                    arrows: false,
                    responsive: [{
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1
                        }
                    }]
                });
            }

            if ($(".home-intro__images > .image").length && $(window).width() < 768) {
                $(".home-intro__images").not('.slick-initialized').slick({
                    slidesToShow: 2,
                    arrows: false,
                    responsive: [{
                        breakpoint: 9999,
                        settings: 'unslick'
                    }, {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1
                        }
                    }]
                });
            }

            if ($('.address-education--item').length > 0) {
                $('.address-education--item select[name="nationalityId"]').change(function () {
                    var data = $(this).val();
                    if (data == 46) {
                        $('.address-education--item .input__field.we-chat-account').show(500);
                    } else {
                        $('.address-education--item .input__field.we-chat-account').hide(500);
                    }
                });
            }

            if ($(".extra__item").length > 0) {
                $(".extra__main").not('.slick-initialized').slick({
                    slidesToShow: 1,
                    arrows: false,
                    dots: false,
                    infinite: false,
                    responsive: [{
                        breakpoint: 9999,
                        settings: 'unslick'
                    }, {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2.2
                        }
                    }, {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1.2
                        }
                    }]
                });
            }

            // $('a[href^=\\#]').on('click', function(event){
            //     event.preventDefault();
            //     $('html,body').animate({scrollTop:$(this.hash).offset().top}, 800);
            // });

            //Gravity Form
            validateFormGravity();

            function validateFormGravity() {

                $('input.datepicker').removeAttr('placeholder');

                $(".gfield input").each(function (index, element) {
                    var id_text = ($(this).attr('id'));
                    if(id_text.slice(0, 15) != 'gforms_calendar'){
                        if($(this).val() != ''){
                            $(this).closest(".gfield").addClass('active');
                        }
                    }
                });

                $(".gfield input,.gfield select").focus(function () {
                    $(this).closest(".gfield").addClass('active');
                });

                $(".gfield select").focus(function () {
                    $(this).closest(".gfield").addClass('focused');
                });

                $(".gfield input").blur(function () {
                    var val = $(this).val();

                    if (val == '') {
                        $(this).closest(".gfield").removeClass('active');
                    }
                });

                $(".gf-default-disabled").prop("disabled", false);

                $(".gfield select").closest(".gfield").addClass("active");

                $(".gfield input").on('change', function (e) {
                    var val = $(this).val();
                    if (val == '') {
                        $(this).closest(".gfield").removeClass('active');
                    } else {
                        $(this).closest(".gfield").addClass('active');
                    }
                });

                $('.gfield textarea').focus(function(){
                    var val = $(this).val();
                    if (val == '') {
                        $(this).closest(".gfield").addClass('active');
                    }
                });

                $('.ginput_container_radio, .ginput_container_checkbox').each(function (i, e) {
                    $(this).closest('.gfield').addClass('choose-input');
                });

                $('.gfield textarea').focusout(function(){
                    var val = $(this).val();
                    if (val == '') {
                        $(this).closest(".gfield").removeClass('active');
                    }
                });

                if ($(".gfield textarea").length > 0) {
                    document.querySelector('.gfield textarea').addEventListener('input', function (event) {
                        var val = $(this).val();
                        if (val == '') {
                            $(this).closest(".gfield").removeClass('active');
                        } else {
                            $(this).closest(".gfield").addClass('active');
                        }
                    });
                }

                // $(".gfield input,.gfield select").change(function () {
                //     var val = $(this).val();
                //
                //     console.log(val);
                //
                //     if(val == ''){
                //         $(this).closest(".gfield").removeClass('active');
                //     }else{
                //         $(this).closest(".gfield").addClass('active');
                //     }
                // });

                // if ($('.ginput_container_select').length > 0) {
                // $('.ginput_container_select').find('.gf_placeholder').html('');
                // $('.ginput_container_select select').change(function () {
                //     console.log($(this).val());
                //     if ($(this).val() != '') {
                //         $(this).parent().parent().addClass('active');
                //     } else {
                //         $(this).parent().parent().removeClass('active');
                //     }
                // });
                // }

                // if ($('.ginput_wrapper_text').length > 0) {
                //     $(".ginput_wrapper_text input").focus(function () {
                //         $(this).parent().parent().addClass('active');
                //     });
                //     $(".ginput_wrapper_text input").blur(function () {
                //         if ($(this).val().length > 1) {
                //             return;
                //         }
                //         $(this).parent().parent().removeClass('active');
                //     });
                //     $(".ginput_wrapper_text input").change(function () {
                //         console.log($(this).val().length);
                //         if ($(this).val().length > 1) {
                //             return;
                //         }
                //         $(this).parent().parent().removeClass('active');
                //     });
                // }


            }
            // if ($('.contact-page').length > 0) {
            //     var stickImage = new StickySidebar('.desktop .contact-page__content--sticky', {
            //         topSpacing: 40,
            //         bottomSpacing: 20,
            //         containerSelector: '.main scape_wrapper_contact',
            //         innerWrapperSelector: '.desktop.contact-page',
            //         minWidth: 991
            //     });
            // }

            jQuery(document).bind('gform_post_render', function () {

                validateFormGravity();
            });

            $.fancybox.defaults.loop = true;
        }


        setHeightBlock();

        function setHeightBlock() {
            if ($('.room__booked--content').length > 0) {
                if ($(window).width() >= 991) {
                    var selects = $('.room__booked--content');
                    selects.each(function (index, element) {
                        $(this).find('h2').css('height', 'auto');
                        $(this).find('.decs').css('height', 'auto');
                    });
                    selects.each(function (index, element) {
                        if (index % 2 == 0 && index !== selects.length - 1) {
                            var $nextElement = selects.eq(index + 1);
                            var $H2_height1 = $(this).find('h2').height();
                            var $H2_height2 = $nextElement.find('h2').height();
                            if ($H2_height1 < $H2_height2) $H2_height1 = $H2_height2;
                            $(this).find('h2').height($H2_height1);
                            $nextElement.find('h2').height($H2_height1);

                            var $H2_height1 = $(this).find('.decs').height();
                            var $H2_height2 = $nextElement.find('.decs').height();
                            if ($H2_height1 < $H2_height2) $H2_height1 = $H2_height2;
                            $(this).find('.decs').height($H2_height1);
                            $nextElement.find('.decs').height($H2_height1);
                        }
                    });
                }
            }


            if ($('.properties-room-detail--items').length > 0) {
                var maxHeight = -1;
                $('.properties-room-detail--items .properties-room-detail--item-content .detail').each(function () {
                    $(this).css('height', 'auto');
                });
                $('.properties-room-detail--items .properties-room-detail--item-content .detail').each(function () {
                    maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
                });
                $('.properties-room-detail--items .properties-room-detail--item-content .detail').each(function () {
                    $(this).height(maxHeight);
                });
            }


            if ($('.image-setheight-pc').length > 0) {
                var maxHeight = -1;
                $('.image-setheight-pc').each(function () {
                    $(this).css('height', 'auto');
                });
                $('.image-setheight-pc').each(function () {
                    maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
                });
                $('.image-setheight-pc').each(function () {
                    $(this).height(maxHeight);
                });
            }
        }

        $(window).on('load', function() {



        });
        jQuery(document).bind('gform_post_render', function () {
            if ($('.contact-page').length > 0) {
                // var fix_sidebar = new StickySidebar('.desktop .contact-page__content', {
                //     topSpacing: 0,
                //     lastTopSpacing: 0,
                //     lastBottomSpacing: false,
                //     bottomSpacing: function() {
                //         var limit = 90;
                //         return limit;
                //     },
                //     containerSelector: '.contact-page.desktop',
                //     minWidth: 991,
                //     resizeSensor: true,
                //     innerWrapperSelector: '.desktop .contact-page__content--sticky',
                // });
            }
        });
        $(window).resize(function () {
            //location.reload();
            slidersubmenu();
            mobileSlider();
            bannerHeightCaculator();
            setHeightBlock();
        });
    });
})(jQuery);
//
//# sourceMappingURL=main.js.map
